module.exports = __webpack_public_path__ + "b1627fb966b508ad33d4397f8f1eab7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/_W7.jpg
// module id = 3500
// module chunks = 0